import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../app/api/routes';
import { APPS_RESOURCE, APP_RESOURCE, UPDATE_APP_RESOURCE } from '../constants';
import { createErrorMessage } from '../../app/helpers/createErrorMessage';

export default ComposedComponent =>
  reduxFetch([
    {
      resource: UPDATE_APP_RESOURCE,
      method: 'put',
      request: (id, body, callback, t) => ({
        url: apiRoutes.apps(id),
        body,
        meta: {
          callback,
          updateOtherList: {
            resource: APPS_RESOURCE,
            idProp: 'id',
            id,
            valuesModifier: values => ({ ...body, ...values }),
          },
          setOther: {
            resource: APP_RESOURCE,
          },
          toaster: {
            onErrorMessage: createErrorMessage(t, 'updateAppFailed'),
            onSuccessMessage: t('updateAppSuccess'),
          },
        },
      }),
    },
  ])(ComposedComponent);
